import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { getArticleBySlug } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

const articleImages: Record<string, string> = {
  "artigo-hoobuy-spreadsheet": "https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20organized%20spreadsheet%20data%20on%20screen%2C%20surrounded%20by%20premium%20sneakers%20and%20fashion%20accessories%20arranged%20on%20clean%20warm%20beige%20desk%2C%20soft%20natural%20window%20lighting%20from%20right%20side%2C%20editorial%20product%20photography%20style%2C%20warm%20cream%20and%20sand%20tones%2C%20high%20detail%20composition%2C%20neat%20organized%20layout%2C%20professional%20aesthetic%2C%20no%20clutter&width=1200&height=600&seq=art-v2-header-01&orientation=landscape",
  "como-economizar-hoobuy": "https://readdy.ai/api/search-image?query=Money%20saving%20concept%20with%20fashion%20products%2C%20a%20glass%20jar%20filled%20with%20coins%20next%20to%20premium%20sneakers%20and%20designer%20wallet%20on%20light%20cream%20surface%2C%20piggy%20bank%20in%20background%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%20style%2C%20warm%20beige%20and%20sand%20tones%2C%20minimalist%20composition%2C%20financial%20freedom%20aesthetic%2C%20clean%20organized%20layout&width=1200&height=600&seq=art-v2-header-02&orientation=landscape",
  "hoobuy-e-seguro": "https://readdy.ai/api/search-image?query=Security%20shield%20concept%20with%20padlock%20and%20fashion%20accessories%20on%20cream%20desk%20surface%2C%20premium%20watch%20and%20sunglasses%20beside%20a%20metallic%20lock%2C%20soft%20natural%20light%2C%20editorial%20photography%20style%2C%20warm%20neutral%20beige%20tones%2C%20trust%20and%20protection%20symbolism%2C%20clean%20minimalist%20composition%2C%20high%20trust%20aesthetic&width=1200&height=600&seq=art-v2-header-03&orientation=landscape",
  "top-100-produtos-hoobuy": "https://readdy.ai/api/search-image?query=Collection%20of%20diverse%20premium%20fashion%20products%20including%20sneakers%2C%20watches%2C%20sunglasses%2C%20and%20leather%20goods%20arranged%20in%20grid%20pattern%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%20from%20above%2C%20editorial%20catalog%20photography%2C%20warm%20beige%20and%20sand%20tones%2C%20organized%20luxury%20aesthetic%2C%20clean%20composition%2C%20trophy%20award%20concept&width=1200&height=600&seq=art-v2-header-04&orientation=landscape",
  "hoobuy-vs-pandabuy": "https://readdy.ai/api/search-image?query=Comparison%20concept%20with%20two%20distinct%20product%20groups%20on%20split%20cream%20background%2C%20left%20side%20modern%20sneakers%20and%20streetwear%2C%20right%20side%20similar%20items%20with%20different%20arrangement%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20warm%20neutral%20sand%20tones%2C%20balanced%20composition%2C%20choice%20and%20decision%20concept&width=1200&height=600&seq=art-v2-header-05&orientation=landscape",
  "melhor-agente-compra": "https://readdy.ai/api/search-image?query=Professional%20shopping%20agent%20concept%20with%20laptop%20and%20fashion%20products%20on%20clean%20cream%20desk%2C%20magnifying%20glass%20over%20products%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20photography%20style%2C%20warm%20beige%20tones%2C%20trust%20and%20verification%20aesthetic%2C%20minimalist%20composition%2C%20international%20shipping%20theme%20with%20small%20globe&width=1200&height=600&seq=art-v2-header-06&orientation=landscape",
  "guia-sneakers-hoobuy": "https://readdy.ai/api/search-image?query=Artistic%20sneaker%20collection%20display%20on%20warm%20cream%20surface%2C%20multiple%20pairs%20of%20trendy%20sneakers%20in%20various%20styles%20arranged%20in%20gradient%20layout%2C%20soft%20natural%20light%20from%20above%2C%20editorial%20fashion%20photography%2C%20warm%20sand%20and%20beige%20tones%2C%20sneakerhead%20aesthetic%2C%20clean%20modern%20composition%2C%20high%20detail%20footwear&width=1200&height=600&seq=art-v2-header-07&orientation=landscape",
  "guia-streetwear-hoobuy": "https://readdy.ai/api/search-image?query=Streetwear%20fashion%20flat%20lay%20with%20hoodies%2C%20graphic%20t-shirts%2C%20caps%20and%20chains%20arranged%20artistically%20on%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20street%20style%20photography%2C%20warm%20beige%20and%20sand%20tones%2C%20urban%20fashion%20aesthetic%2C%20clean%20composition%2C%20contemporary%20youth%20culture%20vibe&width=1200&height=600&seq=art-v2-header-08&orientation=landscape",
  "guia-acessorios-hoobuy": "https://readdy.ai/api/search-image?query=Luxury%20accessories%20display%20with%20designer%20handbags%2C%20leather%20belts%2C%20elegant%20perfume%20bottles%20and%20sunglasses%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20fashion%20photography%2C%20warm%20sand%20tones%2C%20sophisticated%20aesthetic%2C%20high%20detail%20leather%20and%20glass%20textures%2C%20clean%20composition&width=1200&height=600&seq=art-v2-header-09&orientation=landscape",
  "dicas-compra-segura": "https://readdy.ai/api/search-image?query=Safe%20shopping%20concept%20with%20credit%20card%2C%20padlock%20icon%2C%20and%20fashion%20accessories%20on%20clean%20cream%20desk%20surface%2C%20protective%20shield%20symbolism%2C%20soft%20natural%20light%2C%20editorial%20photography%20style%2C%20warm%20beige%20and%20sand%20tones%2C%20consumer%20protection%20aesthetic%2C%20minimalist%20secure%20composition%2C%20trust%20badges&width=1200&height=600&seq=art-v2-header-10&orientation=landscape"
};

export default function ArtigoPage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-32 text-center bg-background-50">
          <p className="text-foreground-500">Artigo não encontrado.</p>
          <Link to="/" className="text-accent-600 font-semibold mt-4 inline-block">Voltar ao início</Link>
        </main>
        <Footer />
      </>
    );
  }

  const viewCount = (article.sections.length * 1.4 + 6.5).toFixed(1);

  return (
    <>
      <Navbar />
      <main>
        {/* Article Header */}
        <section className="relative pt-36 pb-20 md:pt-44 md:pb-28 bg-background-50">
          <div className="max-w-[880px] mx-auto px-6 md:px-16">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-foreground-700 cursor-pointer transition-colors whitespace-nowrap">Home</Link>
              <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center"></i>
              <Link to="/" className="hover:text-foreground-700 cursor-pointer transition-colors whitespace-nowrap">Guias de Compra</Link>
              <i className="ri-arrow-right-s-line text-xs w-3 h-3 flex items-center justify-center"></i>
              <span className="text-foreground-800 font-medium whitespace-nowrap">{article.category}</span>
            </nav>

            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-5 whitespace-nowrap">
              {article.category}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {article.title}
            </h1>

            <p className="mt-5 text-foreground-500 text-sm md:text-base max-w-2xl leading-relaxed">
              {article.metaDescription}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
                Atualizado: Junho 2026
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                Leitura: {article.sections.length * 2} min
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                {viewCount}k visualizações
              </span>
            </div>

            <div className="mt-10 rounded-3xl overflow-hidden">
              <img
                src={articleImages[article.slug] || articleImages["artigo-hoobuy-spreadsheet"]}
                alt={article.title}
                title={article.title}
                className="w-full h-[320px] md:h-[440px] object-cover object-top"
              />
            </div>

            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": article.title,
              "description": article.metaDescription,
              "image": articleImages[article.slug] || articleImages["artigo-hoobuy-spreadsheet"],
              "author": {
                "@type": "Organization",
                "name": "Hoobuy Spreadsheet",
                "url": "https://hoobuy.surf"
              },
              "publisher": {
                "@type": "Organization",
                "name": "Hoobuy Spreadsheet",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg"
                }
              },
              "datePublished": "2026-06-01",
              "dateModified": "2026-06-26",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": `https://hoobuy.surf/guia/${article.slug}`
              },
              "inLanguage": "pt-BR",
              "articleSection": article.category
            }) }} />
          </div>
        </section>

        {/* Table of Contents */}
        <section className="py-8 bg-background-100">
          <div className="max-w-[880px] mx-auto px-6 md:px-16">
            <div className="bg-white rounded-2xl p-6 md:p-8 border border-secondary-200">
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 flex items-center gap-2 whitespace-nowrap">
                <i className="ri-list-unordered w-4 h-4 flex items-center justify-center"></i>
                Neste Artigo
              </h4>
              <ul className="space-y-2">
                {article.sections.map((section, idx) => (
                  <li key={idx}>
                    <a
                      href={`#section-${idx}`}
                      className="text-sm text-foreground-600 hover:text-accent-700 cursor-pointer transition-colors whitespace-nowrap flex items-center gap-2"
                    >
                      <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-bold">
                        {idx + 1}
                      </span>
                      {section.heading}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href="#faq"
                    className="text-sm text-foreground-600 hover:text-accent-700 cursor-pointer transition-colors whitespace-nowrap flex items-center gap-2"
                  >
                    <i className="ri-question-answer-line w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs"></i>
                    FAQ - Perguntas Frequentes
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Article Content */}
        <article className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[880px] mx-auto px-6 md:px-16">
            <div className="prose-content space-y-16">
              {article.sections.map((section, idx) => (
                <section key={idx} id={`section-${idx}`}>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                    {section.heading}
                  </h2>
                  <div className="text-foreground-600 leading-relaxed space-y-4 text-sm md:text-base">
                    <p>{section.content}</p>
                  </div>
                </section>
              ))}
            </div>

            {/* Mid-article CTA */}
            <div className="mt-16 rounded-3xl bg-accent-50/80 p-8 md:p-10 text-center">
              <h3 className="text-xl font-heading font-bold text-foreground-950">
                Pronto para começar a economizar?
              </h3>
              <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
                Acesse agora o hoobuyspreadsheet completo e descubra os melhores produtos antes que esgotem.
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 h-12 px-7 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
                >
                  Acessar HoobuySpreadsheet
                  <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link
                  to="/"
                  className="flex items-center gap-2 h-12 px-7 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-white transition-all"
                >
                  Voltar ao Início
                  <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            {/* FAQ Section */}
            <section id="faq" className="mt-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
                FAQ - Perguntas Frequentes
              </h2>
              <div className="space-y-3">
                {article.faq.map((item, idx) => (
                  <details key={idx} className="group border border-secondary-200 rounded-2xl overflow-hidden bg-white">
                    <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none select-none">
                      <span className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</span>
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 group-open:bg-accent-100 group-open:text-accent-700 transition-colors">
                        <i className="ri-add-line text-sm group-open:hidden"></i>
                        <i className="ri-subtract-line text-sm hidden group-open:block"></i>
                      </span>
                    </summary>
                    <div className="px-6 pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            {/* Related Categories */}
            <section className="mt-16">
              <h3 className="text-xl font-heading font-bold text-foreground-950 mb-6">
                Explore as Categorias do HoobuySpreadsheet
              </h3>
              <div className="flex flex-wrap gap-2">
                {categories.slice(0, 14).map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-xs font-medium hover:bg-accent-100 hover:text-accent-700 cursor-pointer transition-colors whitespace-nowrap"
                  >
                    {cat.namePt}
                  </a>
                ))}
              </div>
            </section>

            {/* Back to Home */}
            <div className="mt-16 pt-10 border-t border-secondary-200 text-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm font-semibold text-accent-700 hover:text-accent-800 cursor-pointer transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-left-line text-sm w-4 h-4 flex items-center justify-center"></i>
                Voltar para a Página Inicial do HoobuySpreadsheet
              </Link>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}